import React, { Fragment, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import clsx from "clsx";
import { Switch, Route } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Workspace, Header, SidebarWrapper } from "../components";
import RoutesDashboard from "../RoutesDashboard";
import RoutesDashboardNtt from "../RoutesDashboardNtt";
import RoutesDashboardNoReport from "../RoutesDashboardNoReport";
import DashboardStyles from "./DashboardStyles";

function resizeDispatch() {
  if (typeof Event === "function") {
    window.dispatchEvent(new Event("resize"));
  } else {
    const evt = window.document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
  }
}

const Dashboard = (props) => {
  const {
    classes,
    filterDrawerState,
    currentPage,
    handleLogout,
    isAuthenticated,
    location,
  } = props;
  const [opened, setOpened] = useState(true);

  const handleDrawerToggle = useCallback(() => {
    setOpened((prevOpened) => !prevOpened);
    resizeDispatch();
  }, []);

  const accessKey =
    props.accessKey != null ? props.accessKey : localStorage.getItem("access_key");
  const isTepcoMenu = accessKey === "undefined" || accessKey === "td94cq1n92ivx6q7hpu3uxvn";
  const isNoReportMenu = accessKey === "k3v9q1m7x8d2p5n0z6h4w1r9";
  const dashboardRoutes = isNoReportMenu
                            ? RoutesDashboardNoReport
                            : isTepcoMenu
                              ? RoutesDashboard
                              : RoutesDashboardNtt;

  // const dashboardRoutes = RoutesDashboard;
  const getRoutes = (
    <Switch>
      {dashboardRoutes.items.map((item, index) => (
        <Route
          exact
          path={item.path}
          component={item.component}
          name={item.name}
          key={index}
        />
      ))}
    </Switch>
  );

  return (
    <Fragment>
      <Header
        logoAltText=""
        logo={`/static/images/logo-main.png`}
        toggleDrawer={handleDrawerToggle}
        isAuthenticated={isAuthenticated}
        handleLogout={handleLogout}
        currentLocation={location.pathname}
      />
      <div className={classNames(classes.panel, "theme-dark")}>
        {!currentPage.includes("viewer") && (
          <SidebarWrapper
            routes={dashboardRoutes.items}
            opened={opened}
            toggleDrawer={handleDrawerToggle}
            handleLogout={handleLogout}
          />
        )}
        <div
          className={clsx(classes.content, {
            [classes.contentShift]: filterDrawerState,
          })}
        >
          <Workspace opened={opened} currentLocation={location.pathname}>
            {getRoutes}
          </Workspace>
        </div>
      </div>
    </Fragment>
  );
};

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  accessKey: PropTypes.string,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(DashboardStyles, { withTheme: true })(Dashboard));
